import { createAsyncThunk } from '@reduxjs/toolkit';

import { APIDataProvider, ApiPaths, TApiResponse } from '../../api';
import { IBookmark } from '.';

const apiDataProvider = new APIDataProvider();

export const createBookmark = createAsyncThunk(
  'user/bookmark/create',
  async (data: IBookmark) => {
    const response = await apiDataProvider.post<TApiResponse<IBookmark>>(
      `${ApiPaths.bookmarks}`,
      data
    );

    return response.data;
  }
);

export const getBookmark = createAsyncThunk(
  'user/bookmark/get',
  async (data: { tutorId: string; studentId: string; subject: string }) => {
    const path = `${ApiPaths.bookmarks}?tutorId=${data.tutorId}&studentId=${data.studentId}&subject=${data.subject}`;

    const response = await apiDataProvider.get<TApiResponse<IBookmark>>(path);

    return response.data;
  }
);
